/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const SETTINGS_FETCH_REQUEST = 'SETTINGS_FETCH_REQUEST';
export const SETTINGS_FETCH_REQUEST_SUCCESS = 'SETTINGS_FETCH_REQUEST_SUCCESS';
export const SETTINGS_FETCH_REQUEST_FAILURE = 'SETTINGS_FETCH_REQUEST_FAILURE';

export const SETTINGS_UPDATE_REQUEST = 'SETTINGS_UPDATE_REQUEST';
export const SETTINGS_UPDATE_REQUEST_SUCCESS = 'SETTINGS_UPDATE_REQUEST_SUCCESS';
export const SETTINGS_UPDATE_REQUEST_FAILURE = 'SETTINGS_UPDATE_REQUEST_FAILURE';

export const SETTINGS_FETCH_TAX_REQUEST = 'SETTINGS_FETCH_TAX_REQUEST';
export const SETTINGS_FETCH_TAX_REQUEST_SUCCESS = 'SETTINGS_FETCH_TAX_REQUEST_SUCCESS';
export const SETTINGS_FETCH_TAX_REQUEST_FAILURE = 'SETTINGS_FETCH_TAX_REQUEST_FAILURE';

export const SETTINGS_UPDATE_TAX_REQUEST = 'SETTINGS_UPDATE_TAX_REQUEST';
export const SETTINGS_UPDATE_TAX_REQUEST_SUCCESS = 'SETTINGS_UPDATE_TAX_REQUEST_SUCCESS';
export const SETTINGS_UPDATE_TAX_REQUEST_FAILURE = 'SETTINGS_UPDATE_TAX_REQUEST_FAILURE';

export const SETTINGS_CSV_HISTORY_FETCH_REQUEST = 'SETTINGS_CSV_HISTORY_FETCH_REQUEST';
export const SETTINGS_CSV_HISTORY_FETCH_REQUEST_SUCCESS =
  'SETTINGS_CSV_HISTORY_FETCH_REQUEST_SUCCESS';
export const SETTINGS_CSV_HISTORY_FETCH_REQUEST_FAILURE =
  'SETTINGS_CSV_HISTORY_FETCH_REQUEST_FAILURE';

export const SETTINGS_CSV_UPLOAD_REQUEST = 'SETTINGS_CSV_UPLOAD_REQUEST';
export const SETTINGS_CSV_UPLOAD_REQUEST_SUCCESS = 'SETTINGS_CSV_UPLOAD_REQUEST_SUCCESS';
export const SETTINGS_CSV_UPLOAD_REQUEST_FAILURE = 'SETTINGS_CSV_UPLOAD_REQUEST_FAILURE';
export const SETTINGS_CSV_UPLOAD_CLEAN_REQUEST = 'SETTINGS_CSV_UPLOAD_CLEAN_REQUEST';

export const SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST = 'SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST';
export const SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST_SUCCESS =
  'SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST_SUCCESS';
export const SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST_FAILURE =
  'SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST_FAILURE';
export const SETTINGS_CSV_UPLOAD_CONFIRM_CLEAN_REQUEST =
  'SETTINGS_CSV_UPLOAD_CONFIRM_CLEAN_REQUEST';

export const SETTINGS_FETCH_COLOR_REQUEST = 'SETTINGS_FETCH_COLOR_REQUEST';
export const SETTINGS_FETCH_COLOR_REQUEST_SUCCESS = 'SETTINGS_FETCH_COLOR_REQUEST_SUCCESS';
export const SETTINGS_FETCH_COLOR_REQUEST_FAILURE = 'SETTINGS_FETCH_COLOR_REQUEST_FAILURE';

export const APPOINTMENT_POLICY_FETCH_REQUEST = 'APPOINTMENT_POLICY_FETCH_REQUEST';
export const APPOINTMENT_POLICY_FETCH_REQUEST_SUCCESS = 'APPOINTMENT_POLICY_FETCH_REQUEST_SUCCESS';
export const APPOINTMENT_POLICY_FETCH_REQUEST_FAILURE = 'APPOINTMENT_POLICY_FETCH_REQUEST_FAILURE';

export const APPOINTMENT_POLICY_UPSERT_REQUEST = 'APPOINTMENT_POLICY_UPSERT_REQUEST';
export const APPOINTMENT_POLICY_UPSERT_REQUEST_SUCCESS =
  'APPOINTMENT_POLICY_UPSERT_REQUEST_SUCCESS';
export const APPOINTMENT_POLICY_UPSERT_REQUEST_FAILURE =
  'APPOINTMENT_POLICY_UPSERT_REQUEST_FAILURE';

export const SETTINGS_CLEAN_REQUEST = 'SETTINGS_CLEAN_REQUEST';

export const SETTINGS_FETCH_CUSTOM_STATUS_REQUEST = 'SETTINGS_FETCH_CUSTOM_STATUS_REQUEST';
export const SETTINGS_FETCH_CUSTOM_STATUS_REQUEST_SUCCESS =
  'SETTINGS_FETCH_CUSTOM_STATUS_REQUEST_SUCCESS';
export const SETTINGS_FETCH_CUSTOM_STATUS_REQUEST_FAILURE =
  'SETTINGS_FETCH_CUSTOM_STATUS_REQUEST_FAILURE';

export const SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST = 'SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST';
export const SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST_SUCCESS =
  'SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST_SUCCESS';
export const SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST_FAILURE =
  'SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST_FAILURE';

export const SETTINGS_BILLING_REQUEST = 'SETTINGS_BILLING_REQUEST';
export const SETTINGS_BILLING_REQUEST_SUCCESS = 'SETTINGS_BILLING_REQUEST_SUCCESS';
export const SETTINGS_BILLING_REQUEST_FAILURE = 'SETTINGS_BILLING_REQUEST_FAILURE';

export const COLUMN_HEADER_MAP_REQUEST = 'COLUMN_HEADER_MAP_REQUEST';
export const COLUMN_HEADER_MAP_REQUEST_SUCCESS = 'COLUMN_HEADER_MAP_REQUEST_SUCCESS';
export const COLUMN_HEADER_MAP_REQUEST_FAILURE = 'COLUMN_HEADER_MAP_REQUEST_FAILURE';

export const CLEAN_CSV_HEADER_MAP_REQUEST = 'CLEAN_CSV_HEADER_MAP_REQUEST';

export const CONFIGURE_DOCUMENTS_NUMBER = 'CONFIGURE_DOCUMENTS_NUMBER';
export const CONFIGURE_DOCUMENTS_NUMBER_SUCCESS = 'CONFIGURE_DOCUMENTS_NUMBER_SUCCESS';
export const CONFIGURE_DOCUMENTS_NUMBER_FAILURE = 'CONFIGURE_DOCUMENTS_NUMBER_FAILURE';
